import { render, staticRenderFns } from "./EnlargeGalleryImage.vue?vue&type=template&id=33936b26&scoped=true&"
import script from "./EnlargeGalleryImage.vue?vue&type=script&lang=js&"
export * from "./EnlargeGalleryImage.vue?vue&type=script&lang=js&"
import style0 from "./EnlargeGalleryImage.vue?vue&type=style&index=0&id=33936b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33936b26",
  null
  
)

export default component.exports